import { Component } from '@angular/core';
import { MachineListComponent } from './components/machine-list/machine-list.component';

@Component({
    selector: 'app-machines-view',
    imports: [MachineListComponent],
    templateUrl: './machines-view.component.html',
    styleUrl: './machines-view.component.scss'
})
export class MachinesViewComponent {

}
